export default __webpack_public_path__ + "static/media/loading-spinner.08eaf775.gif";